module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTkiIHZpZXdCb3g9IjAgMCAxNSAxOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggb3BhY2l0eT0iMC41IiBkPSJNMC42NDk5MDIgMC42NDk5OTRWMTcuNjVMNy4wMjczNSAxMy40TDEzLjY0OTkgMTcuNjVWMC42NDk5OTRIMC42NDk5MDJaIiBzdHJva2U9IiMwMDIzMkEiIHN0cm9rZS13aWR0aD0iMS4zIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ico-svg/Rzón social.svg
// module id = Xdwo
// module chunks = 62